import React from "react";
import { SessionCard } from "../../LiveSearchHelper";
import noDataImage from "../../../../../../images/nodata2.png";
import Pagination from "../../Pagination";

/**
 * Renders either the session card grid or the "no data" placeholder.
 * Owns no state — purely presentational.
 */
export default function SessionList({
  dateWiseData,
  platformWiseFilterData,
  selectedPlatform,
  // SSE badges
  newIds,
  updatedIds,
  // Actions
  crawlIsLoading,
  currentPage,
  totalPageCount,
  onPageChange,
  onFetchCards,
  onRetryCrawl,
  onViewRaw,
  onViewProcessed,
  onDownloadClick,
}) {
  const hasDateData =
    Array.isArray(dateWiseData) && dateWiseData.length > 0;
  const hasPlatformData =
    Array.isArray(platformWiseFilterData) && platformWiseFilterData.length > 0;
  const isEmpty = !hasDateData && !hasPlatformData;

  // Which list to render?
  const sessions = hasPlatformData
    ? platformWiseFilterData
    : hasDateData
      ? dateWiseData
      : [];

  if (isEmpty) {
    return (
      <div
        style={{
          width: "160vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={noDataImage} alt="No Data Found" style={{ width: "75vh" }} />
      </div>
    );
  }

  // Platform filter active but no matching results
  if (
    selectedPlatform.length !== 0 &&
    Array.isArray(platformWiseFilterData) &&
    platformWiseFilterData.length === 0
  ) {
    return (
      <div
        style={{
          width: "160vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={noDataImage} style={{ width: "75vh" }} alt="No Data" />
      </div>
    );
  }

  return (
    <div>
      <div className="c-crawled-data">
        {sessions.map((session, index) => (
          <SessionCard
            key={session._id?.toString?.() || `session-${index}`}
            session={session}
            isNew={newIds.has(session._id)}
            isUpdated={updatedIds.has(session._id)}
            fetchSessionCards={onFetchCards}
            crawlIsloadings={crawlIsLoading}
            currentPage={currentPage}
            selectedPlatform={selectedPlatform}
            onRetryCrawl={onRetryCrawl}
            onViewRaw={() => onViewRaw(session)}
            onViewProcessed={() => onViewProcessed(session)}
            onDownloadClick={onDownloadClick}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPageCount={totalPageCount}
        handlePageChange={onPageChange}
      />
    </div>
  );
}
